import { Drawer, Form } from 'antd';
import { QueryDrawerProps } from './interface';
import IssueForm from '../../../../components/issueForm';
import { QueryType } from '../../../../types';
import CauseForm from '../../../../components/causeForm';
import { selectDraftTemplate } from '../../../../slices/templates';
import { useSelector } from 'react-redux';
import RoutineForm from '../../../../components/routineForm';
import { suggestionTitles } from '../../../../constants';
import { useAppDispatch } from '../../../../store';
import { fetchNotifications } from '../../../../slices/notifications';

const SuggestionDrawer = ({
  queryType,
  visible,
  onClose,
}: QueryDrawerProps) => {
  const dispatch = useAppDispatch();
  const [form] = Form.useForm();
  const { templateID } = useSelector(selectDraftTemplate) || {};
  const title = suggestionTitles[queryType];

  const handleSubmit = () => {
    dispatch(fetchNotifications());
    onClose();
  };

  const renderForm = () => {
    switch (queryType) {
      case QueryType.ISSUE:
        return (
          <IssueForm
            templateID={String(templateID)}
            form={form}
            onCancel={onClose}
            onSubmit={handleSubmit}
            isSuggestion
          />
        );
      case QueryType.CASUE:
        return (
          <CauseForm
            templateID={String(templateID)}
            form={form}
            onCancel={onClose}
            onSubmit={handleSubmit}
            isSuggestion
          />
        );
      case QueryType.ROUTINE:
        return (
          <RoutineForm
            form={form}
            onCancel={onClose}
            onSubmit={handleSubmit}
            isSuggestion
          />
        );
      default:
        return null;
    }
  };

  return (
    <Drawer
      title={title}
      closable
      onClose={onClose}
      open={visible}
      width={800}
      push={false}
    >
      <Form form={form} layout="vertical">
        {renderForm()}
      </Form>
    </Drawer>
  );
};

export default SuggestionDrawer;
